/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  
  {
    
    description:
      'Hindi CCA Class 2',
    href : '/my-favourite-animal-2025'
 
  },
  {
    
    description:
      'AVID Reader',
    href : '/avid-reader-2025'
 
  },
  {
    
    description:
      'English CCA',
    href : '/english-cca-2025'
 
  },
  {
    
    description:
      'Pick and Speak',
    href : '/kannada-cca-class-2-2025'
 
  },
  {
    
    description:
      'Hindi CCA Class 1-5',
    href : '/hindi-cca-class-1-to-5-2025'
 
  },
  {
    
    description:
      'Kannada CCA Class 3-5',
    href : '/kannada-cca-class-3-to-5-2025'
 
  },
  {
    
    description:
      'Literary Association',
    href : '/literary-association-class-9-to-12-2025'
 
  } ,
  {
    
    description:
      'Kannada CCA Class 1',
    href : '/kannada-cca-class-1-2025'
 
  },
    {
    
    description:
      'English CCA Class 2',
    href : '/english-cca-class2-2025'
 
  },
   {
    
    description:
      'Hindi CCA Class 1',
    href : '/hindi-cca-class2-2025'
 
  },
  {
    
    description:
      'AVID Reader Class 1-8',
    href : '/avid-readers-2025'
 
  },
  {
    
    description:
      'Junior Literary Association',
    href : '/junior-literary-association-2025'
 
  },
  {
    
    description:
      'AVID Reader Class 1-8 January-February',
    href : '/avid-readers-class-1to8-jan-feb-2025'
 
  },
   {
    
    description:
      'English CCA Class 3-5',
    href : '/English-CCA-Class-3to5-2025'
 
  },

  

  
];

const Sidebar2025 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Literary Club 2025-26
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href={item.href}>
                <Typography variant='h6'>
                  {item.description}
                  
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Sidebar2025;
